
import { useState } from 'react';
import BookingChoiceModal from '../../../components/feature/BookingChoiceModal';

const CTA1Section = () => {
  const [showBookingChoice, setShowBookingChoice] = useState(false);

  return (
    <>
      <section className="py-20 bg-gradient-to-br from-[#24820C] to-[#1a5f09]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Ready to Transform Your Property?
          </h2>
          <p className="text-xl text-green-100 mb-10 max-w-2xl mx-auto">
            Join hundreds of satisfied homeowners in Maryland who trust us with their landscaping needs.
          </p>
          
          <button 
            onClick={() => setShowBookingChoice(true)}
            className="bg-white text-[#24820C] hover:bg-gray-100 font-bold py-5 px-10 rounded-full text-lg transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Book Now
          </button>
        </div>
      </section>

      <BookingChoiceModal isOpen={showBookingChoice} onClose={() => setShowBookingChoice(false)} />
    </>
  );
};

export default CTA1Section;
